import { notification } from "antd";
import Helper from "../../Helper";
import PlotAPI from "../../plotAPI";
import TeamInfo from "../../teamInfo";
import { getActivitiesForProject } from "./Activity";
import { putProjectInfo } from "./Project";
import { getSubmittals } from "./Submittal";

export function getIntegrationSourceCompanies(
    team_subdomain: string,
    project_token: string
): Promise<any[] | { errors: string }> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/integrations_companies";

    const options = { method: "GET" };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function getIntegrationSourceProjects(team_subdomain: string, project_token: string): Promise<any[]> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/integrations_projects";

    const options = { method: "GET" };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function getIntegrationSourceVendors(
    team_subdomain: string,
    project_token: string
): Promise<any[] | { errors: string }> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/integrations_vendors";

    const options = { method: "GET" };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function getIntegrationContactsByVendor(team_subdomain: string, project_token: string): Promise<any[]> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/integrations_contacts_by_vendor";

    const options = { method: "GET" };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function getCompanyIntegrationContacts(
    teamSubdomain: string,
    projectToken: string,
    companyId: number
): Promise<any[]> {
    const url =
        Helper.baseUrlAltSubdomain(teamSubdomain ? teamSubdomain : "projects") +
        "/projects/" +
        projectToken +
        "/integrations_company_contacts";

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ company_id: companyId }),
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function getProjectVendorUsers(
    vendorId: number,
    projectSubdomain: string,
    projectToken: string
): Promise<any[]> {
    const url =
        Helper.baseUrlAltSubdomain(projectSubdomain ? projectSubdomain : "projects") +
        "/projects/" +
        projectToken +
        "/integrations_contacts_by_vendor";

    const options = { method: "POST", body: JSON.stringify({ vendor_id: vendorId }) };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function updateIntegrationSource(
    team_subdomain: string,
    project_token: string,
    company_id: string | null,
    project_id: string | null
): Promise<any | null> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/integrations/1";

    const options = { method: "PUT", body: JSON.stringify({ company_id, project_id }) };

    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return null;
        });
}

export function deleteIntegrationSource(team_subdomain: string, project_token: string): Promise<any | null> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/integrations/1";

    const options = {
        method: "DELETE",
    };

    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return null;
        });
}

export function addTeamIntegrationLink(team: TeamInfo, project: any, vendorId: string): Promise<any | null> {
    const url =
        Helper.baseUrlAltSubdomain(team.subdomain ? team.subdomain : "projects") +
        "/projects/" +
        project.unique_token +
        "/integrations_connect_members";

    const options = {
        method: "POST",
        body: JSON.stringify({ object_id: team.id, object_type: "team", vendor_object_id: vendorId }),
    };

    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return null;
        });
}

export function removeTeamIntegrationLink(team: TeamInfo, project: any): Promise<any | null> {
    const url =
        Helper.baseUrlAltSubdomain(team.subdomain ? team.subdomain : "projects") +
        "/projects/" +
        project.unique_token +
        "/integrations_connect_members";

    const options = {
        method: "DELETE",
        body: JSON.stringify({ object_id: team.id, object_type: "team" }),
    };

    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return null;
        });
}

export function importMembersToJobsite(
    subdomain: string,
    projectToken: string,
    members: any[],
    teamType: "vendor" | "member"
): Promise<any | null> {
    const url = Helper.baseUrlAltSubdomain(subdomain) + "/projects/" + projectToken + "/integrations_import_members";

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ members: members, team_type: teamType }),
    };

    return Helper.plotFetch(url, options)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .catch(() => {
            return null;
        });
}

export function getSyncIntegrationCounts(
    subdomain: string,
    projectToken: string
): Promise<{ total_activities: number; total_submittals: number } | null> {
    const url = Helper.baseUrlAltSubdomain(subdomain) + "/projects/" + projectToken + "/integrations_sync";

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    };

    return Helper.plotFetch(url, options)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .catch(() => {
            return null;
        });
}

export async function getPlotSubmittalsAndActivitiesCounts(
    subdomain: string,
    projectToken: string
): Promise<{ submittals_count: number; activities_count: number } | null> {
    const submittal_count = await getSubmittals(subdomain, projectToken, "UTC").then((res) => res.totalCount);
    const activity_count = await getActivitiesForProject(subdomain, projectToken, "UTC").then((res) => res.totalCount);
    return { submittals_count: submittal_count, activities_count: activity_count };
}

export function syncIntegrationForProject(subdomain: string, projectToken: string): Promise<null> {
    const url = Helper.baseUrlAltSubdomain(subdomain) + "/projects/" + projectToken + "/integrations_sync";

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: null,
    };

    return Helper.plotFetch(url, options)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .catch(() => {
            return null;
        });
}

export const uploadActivityFile = async (projectInfo: any, activityFile: any): Promise<void> => {
    const formData = new FormData();
    const fileBlob = activityFile.originFileObj as Blob;
    formData.append("File", fileBlob);

    return PlotAPI.uploadScheduleForProject(
        projectInfo.claimed_by_team_subdomain || "projects",
        projectInfo.unique_token,
        formData
    )
        .then((res) => {
            if (res) {
                notification.success({
                    message: "File Uploaded",
                    description: "Your activity file has been uploaded successfully.",
                });
                return Promise.resolve();
            } else {
                return Promise.reject(new Error("File upload failed"));
            }
        })
        .catch((err) => {
            notification.error({
                message: "Upload Error",
                description: "There was an error uploading your file. Please try again.",
            });
            return Promise.reject(err);
        });
};

export const updateProjectInfoAndSyncIntegrations = (projectInfo: any, activityFile?: any): Promise<void> => {
    return putProjectInfo(projectInfo.unique_token || "", projectInfo)
        .then((res) => {
            if (res) {
                return Promise.resolve();
            } else {
                throw new Error("Failed to update project info");
            }
        })
        .then((res) => {
            notification.success({
                message: "Sync Started",
                description:
                    "Initial syncs may take several minutes to complete. PLOT will send a notification once the job is complete.",
                duration: 0,
            });
            if (
                projectInfo.submittals_integration_source === "unset" &&
                projectInfo.activities_integration_source === "unset" &&
                !activityFile
            ) {
                return Promise.resolve();
            }
            return PlotAPI.syncIntegrationForProject(
                projectInfo.claimed_by_team_subdomain || "projects",
                projectInfo.unique_token
            );
        })
        .then(() => {
            if (activityFile) {
                return uploadActivityFile(projectInfo, activityFile);
            }
            return Promise.resolve();
        })
        .catch((error) => {
            notification.error({
                message: "Sync Error",
                description: "There was an error starting the sync. Please try again.",
            });
        });
};
